/* eslint-disable jsx-a11y/control-has-associated-label */
/* eslint-disable no-func-assign */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React from 'react';
import {
  FasLock, FasUnLock, FasExclamation, FasPenSquare
} from 'assets/icons';
import { withAppContext } from '@ctsu/loader';
import { RenderElement } from 'components/RenderHelpers';
import { ATCONSTANTS as ATC } from 'appconstants';
import { CanUserLockRecord, CanUserSeeMainGridDocs } from 'appconstants/Permission';
import PacketIButton from 'components/iButton/PacketIButton';
import SupportingDocDownload from './Components/SupportingDocDownload';

function GridActionButtons({ data, events, context }) {
  const { session } = context;
  const { lockedBy } = data;
  const isLocked = lockedBy != null;
  const isLockedByYou = isLocked && lockedBy === session.username;
  const statusHideLockBtn = ['ARCHIVED', 'COMPLETE', 'VOID'];

  let title = 'Not Locked';
  let className = '';
  if (isLocked) {
    title = `Locked by ${isLockedByYou ? 'you' : lockedBy}`;
  }

  if (isLocked) {
    className = isLockedByYou ? 'delete' : 'disabled';
  }

  const lockHandler = () => {
    if (className !== 'disabled') {
      events[0](data);
    }
  };

  const takeHandler = () => {
    events[0](data, true);
  };

  return (
    <span className="icon action-icon-container">
      <RenderElement access={CanUserLockRecord()}>
        {!statusHideLockBtn.includes(data.status) ? (
          <button
            type="button"
            data-id={`${ATC.PACKETID}${data.id}_LOCKED_BY_${data.lockedBy ? data.lockedBy.split(' ')[0].toUpperCase() : 'YOU'}${ATC.BUTTON}`}
            className={`fn-btn ml-1 ${className} bg-transparent ${isLocked ? 'mr-1' : 'mr-0'}`}
            onClick={lockHandler}
            title={title}
            disabled={className === 'disabled'}
          >
            {isLocked ? <FasLock /> : <FasUnLock />}
          </button>
        ) : null}
      </RenderElement>
      <RenderElement access={CanUserLockRecord()}>
        {lockedBy == null ? (
          <button
            type="button"
            data-id={`${ATC.PACKETID}${data.id}_TAKE_${ATC.BUTTON}`}
            className="fn-btn mx-1"
            onClick={(event) => {
              event.stopPropagation();
              takeHandler();
            }}
            title="Take"
          >
            <FasPenSquare style={{ height: '1.25rem', width: '1.25rem' }} />
          </button>
        ) : null}
      </RenderElement>
      <RenderElement access={CanUserSeeMainGridDocs()}>
        <SupportingDocDownload packet={data} />
      </RenderElement>
    </span>
  );
}

GridActionButtons = withAppContext(GridActionButtons);

function RenderIButton({ id, packetId, timeOfNeed }) {
  if (packetId !== null) {
    return (
      <>
        <PacketIButton packetDbId={id} packetId={packetId} />
        <span className={`${timeOfNeed && 'bg-light-red px-2 rounded d-inline-block'}`}>{packetId}</span>
      </>
    );
  }
  return null;
}

const PacketBrowserColumns = [
  {
    name: 'object',
    label: 'Object',
    renderCell: (data) => (data.priority === 'TIME_OF_NEED' ? (
      <>
        <FasExclamation className="color-red mr-1" />
        {data.object}
      </>
    ) : (
      data.object
    ))
  },
  {
    name: 'packetId',
    label: 'Packet ID',
    renderCell: (data) => <RenderIButton id={data.id} packetId={data.packetId} timeOfNeed={data.priority === 'TIME_OF_NEED'} />
  },
  { name: 'priority', label: 'Priority' },
  { name: 'receivedDate', label: 'Received Date' },
  {
    name: 'assignedTo',
    label: 'Assigned To',
    renderCell: (data) => <span>{data.assignedTo}</span>
  },
  { name: 'esysStatusDate', label: 'Status Date' },
  { name: 'status', label: 'Status' },
  { name: 'trackingBarCode', label: 'Tracking Code' },
  { name: 'packetType', label: 'Type' },
  { name: 'lockedBy', label: 'Locked By' },
  {
    name: 'actions',
    label: 'Actions',
    renderCell: (data, events) => <GridActionButtons data={data} events={events} />,
    filterable: false,
    sort: false
  }
];

export default PacketBrowserColumns;
